import { createSlice, createSelector } from '@reduxjs/toolkit'

// import { BASE_URL, OrganizationId, AuthToken } from '/features/storeconfig'



const initialState = {
  entities: {},
  status: 'idle', // idle loading success fail  
  error: null
}



const questionsetSlice = createSlice({
  name: 'questionsets',
  initialState,
  reducers: {
    questionsetAdd(state, action) {
      const questionSetData = action.payload
      state.entities[questionSetData.QuestionSetId] = questionSetData
    },
    questionsetModify(state, action) {
      const questionSetData = action.payload
      state.entities[questionSetData.QuestionSetId] = questionSetData
    },
    questionsetDelete(state, action) {
      const questionSetData = action.payload
      delete state.entities[questionSetData.QuestionSetId]
    },
    questionsetHydrate(state, action) {
        const questionSetData = action.payload
        state.entities=questionSetData
        state.status = 'success'
    },
    questionsetClear(state, action){
      state.status='idle'
    },
    questionsetAnswerSaved(state, action){
      const {QuestionSetId} = action.payload
      const curQuestionSet = state.entities[QuestionSetId]      
      state.entities[QuestionSetId] = {...curQuestionSet, WasChanged:true}
    },
    questionsetValueLimitation(state, action){
      const {QuestionSetId, ValueLimitationPassed, ValueLimitationError} = action.payload      
      const curQuestionSet = state.entities[QuestionSetId]
      state.entities[QuestionSetId] = {...curQuestionSet, ValueLimitationPassed: ValueLimitationPassed, ValueLimitationError:ValueLimitationError, WasChanged:false}
    }
  }
})

export const { questionsetAdd,questionsetModify,questionsetDelete,questionsetHydrate,questionsetAnswerSaved,questionsetValueLimitation } = questionsetSlice.actions

export default questionsetSlice.reducer

const selectQuestionSetEntities = (state) => state.questionsets.entities

export const selectQuestionSets = createSelector(selectQuestionSetEntities, (entities) =>
  Object.values(entities)
)

export const selectQuestionSetById = (state, QuestionSetId) => {
  return selectQuestionSetEntities(state)[QuestionSetId]
}

export const selectQuestionSetsInCurrentSurvey = createSelector(
  selectQuestionSets
  , (state, SurveyId)=>SurveyId
  , (questionsets, SurveyId) => {

    return questionsets.filter((questionset) => {
      return questionset.SurveyId === SurveyId
    })
  }

)


